import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import React, { useContext, useMemo, useState } from 'react';
import { Divider, Grid } from '@mui/material';
import { DeleteIcon } from '../../../../icons/Delete/DeleteIcon';
import { VentoryColor } from '../../../../util/color.util';
import { t } from '../../../../../types/translation/Translator';
import { StockLocationContext } from '../../../../../context/StockLocationContext';
import MultiSelectionList from '../../../common/MultiSelectionList/MultiSelectionList';
import SearchBar from '../../../common/SearchBar/SearchBar';
import { ContainerContext } from '../../../../../context/ContainerContext';
import { ContainerFilter } from '../ContainerFilter';
import { FilterProps } from '../../common/filter.util';

interface ContainerFilterContentProps {
  filter: ContainerFilter;
  filterProps: FilterProps;
  setFilterProps: (filter: FilterProps) => void;
}

export default function ContainerFilterContent({ filter, filterProps, setFilterProps }: ContainerFilterContentProps) {
  const { stockLocations } = useContext(StockLocationContext);
  const { containers } = useContext(ContainerContext);

  const [query, setQuery] = useState<string>('');

  const values = useMemo(() => {
    const items = new Set<string>();
    for (const container of containers.values()) {
      if (!filter.search(container, query)) continue;
      if (filterProps.company?.size && !filterProps.company.has(container.companyId)) continue;
      items.add(container.id);
    }
    return items;
  }, [query, containers, filter]);

  const handleChange = (selected: Set<string>) => {
    filterProps.container = selected;
    if (!filterProps.container?.size) filterProps.container = undefined;
    setFilterProps({ ...filterProps });
  };

  const handleRemove = () => {
    filterProps.container = undefined;
    setFilterProps({ ...filterProps });
  };

  return (
    <Grid container>
      <Grid item xs={12} className='flex px-3 py-2'>
        <Grid container>
          <Grid item>
            <p className='text-[13px] font-[500] text-gray-500'>{t(TranslationKey.container).singular.label}</p>
          </Grid>
          <Grid item flexGrow={1} display={'flex'} justifyContent={'flex-end'} sx={{ color: VentoryColor.deleteRed }}>
            <Grid item onClick={handleRemove} className='cursor-pointer'>
              <DeleteIcon />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <SearchBar onChange={i => setQuery(i)} className='pl-3 pr-4' />
      </Grid>
      <Grid item className='py-3' xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <MultiSelectionList
          selected={filterProps.container}
          values={values}
          onChange={handleChange}
          toText={id => `${containers.get(id)?.identifier}`}
          toSubText={id => `${stockLocations.get(containers.get(id)?.stockLocationId || '')?.name || ''}`}
        />
      </Grid>
    </Grid>
  );
}
